<template>

<div class="c-voting">

    <p v-if="manualSelection.length <= 0 && $ceres.isShopBuilder" style="padding:20px; text-align:center">Es wurden noch keine Artikel hinzugefügt</p>

    <div class="items" :class="{'loading': this.loading}">
        <div class="legend">
            <div class="img" style="order:-9999">
                <div class="inner">
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAXIAAAFyAQMAAADS6sNKAAAAA1BMVEUAAACnej3aAAAAAXRSTlMAQObYZgAAACdJREFUeNrtwQENAAAAwiD7p7bHBwwAAAAAAAAAAAAAAAAAAAAAIOpFYAABNMkVpAAAAABJRU5ErkJggg==" alt="" />
                </div>
            </div>
            <div class="btnsx" style="order:-9999">
                <div class="inner"></div>
            </div>
            <div class="title" style="order:-9999">
                <div class="inner">Bezeichnung:</div>
            </div>
            <div class="price" style="order:-9999">
                <div class="inner">Preis:</div>
            </div>
            <div class="rating" style="order:-9999">
                <div class="inner">Bewertung:</div>
            </div>
            <template v-for="(item, index) in manualSelection">
                <template v-for="property in item.data.variationProperties" v-if="index == 0 && varProps.map(Number).includes(property.property.id)">
                    <div class="var-prop" :class="'vp-' + property.property.id" :style="'order:' + property.property.position">
                        <div class="inner">{{ property.property.names.name }}:</div>
                    </div>
                </template>
            </template>
            <div class="add-disa" style="order:9999">
                <div class="inner">Vor- und Nachteile:</div>
            </div>
            <div class="vote-container" style="order:9999">
                <div class="vote">
                    <div class="inner">Kundenvoting<span id="setTotalVotes"></span>:</div>
                </div>
            </div>
            <!-- <div class="faz" style="order:9999">
                <div class="inner">Fazit von Sebastian:</div>
            </div> -->
            <div class="btns" style="order:10001">
                <div class="inner"></div>
            </div>
        </div>
        <div class="overflow">
            <div v-for="(item, index) in manualSelection" class="i data-count" :class="'i' + item.id" :data-id="'i' + item.id">
                <div class="img" style="order:-9999">
                    <div class="inner">
                        <img :src="item.data.images.all[0].urlMiddle" :alt="item.data.texts.name3">

                        <span v-if="item.id == parseFloat(winner)" class="winner">
                            Preis Leistungs Sieger
                        </span>
                        <span v-if="item.id == parseFloat(recommendation)" class="winner rec">
                            Kauf&shy;empfehlung
                        </span>
                    </div>
                </div>
                <div class="btnsx" style="order:-9999">
                    <div class="inner">
                        <!-- Normaler Artikel -->
                        <template v-for="property in item.data.variationProperties" v-if="property.property.id == 57 && property.values.value == ''">
                            <a :href="'#cross' + item.id" data-toggle="modal" class="a">Jetzt kaufen</a>
                        </template>

                        <!-- Amazon Artikel -->
                        <template v-for="property in item.data.variationProperties" v-if="property.property.id == 57 && property.values.value.startsWith('http')">
                            <a class="amz a" :href="property.values.value" target="_blank">Bei Amazon kaufen</a>
                        </template>
                    </div>
                </div>
                <div class="title" style="order:-9999">
                    <div class="inner">{{ item.data.texts.name3 }}</div>
                </div>
                <div class="price" style="order:-9999">
                    <div class="inner">
                        <template v-for="property in item.data.variationProperties" v-if="property.property.id == 57 && property.values.value == ''">
                            {{ item.data.prices.default.price.formatted }}
                        </template>
                        <template v-for="property in item.data.variationProperties" v-if="property.property.id == 57 && property.values.value == 'x'">
                            <template v-for="property in item.data.variationProperties" v-if="property.property.id == 48">
                                <div v-html="property.values.value"></div>
                            </template>
                        </template>
                        <template v-for="property in item.data.variationProperties" v-if="property.property.id == 57 && property.values.value.startsWith('http')">
                            <template v-for="property in item.data.variationProperties" v-if="property.property.id == 48">
                                <div v-html="property.values.value"></div>
                            </template>
                        </template>
                    </div>
                </div>

                <div class="rating" style="order:-9999">
                    <div class="inner">
                        <template v-for="property in item.data.variationProperties" v-if="property.property.id == 57 && property.values.value == ''">
                            <span class="rate-txt" v-if="item.data.item.feedbackCount">
                                <span class="rate-inner">
                                    <span class="rate-blank"></span>
                                    <span class="rate" :style="'width:' + (item.data.item.feedbackDecimal * 20) + '%'"></span>
                                </span>
                                <span class="txt">({{ item.data.item.feedbackCount }})</span>
                            </span>
                            <span class="rate-txt" v-else>
                                <span class="rate-inner">
                                    <span class="rate-blank"></span>
                                    <span class="rate" style="width:0%"></span>
                                </span>
                                <span class="txt">(0)</span>
                            </span>
                        </template>
                    </div>
                </div>

                <template v-for="property in item.data.variationProperties" v-if="varProps.map(Number).includes(property.property.id)">
                    <div class="var-prop" :class="'vp-' + property.property.id" :style="'order:' + property.property.position">
                        <div class="inner">
                            <template v-if="property.values.value == 'ja'">
                                <i class="icon-yes"></i>
                            </template>
                            <template v-else-if="property.values.value == 'nein'">
                                <i class="icon-no"></i>
                            </template>
                            <template v-else>
                                <div v-html="property.values.value"></div>
                            </template>
                        </div>
                    </div>
                </template>

                <template v-for="property in item.data.variationProperties" v-if="property.property.id == 52">
                    <div class="add-disa" style="order:999">
                        <div class="inner" v-html="property.values.value"></div>
                    </div>
                </template>

                <div class="vote-container" style="order:9999">
                    <template v-for="vote in votingjson" v-if="vote.itemId == item.data.variation.id">
                        <div class="vote y" :data-count="vote.count" :data-percent="vote.percent">
                            <div class="inner">
                                <span class="bar-c"><span class="bar" :style="'width: calc(' + vote.percent + '% - 4px)'"></span></span>
                                <span>{{ vote.percent }}%</span>
                            </div>
                        </div>
                    </template>

                    <!-- empty vote -->
                    <div class="vote">
                        <div class="inner">
                            <span class="bar-c"><span class="bar"></span></span>
                            <span>0%</span>
                        </div>
                    </div>
                </div>

                <!-- <template v-for="property in item.data.variationProperties" v-if="property.property.id == 53">
                    <div class="faz" style="order:9999">
                        <div class="inner" v-html="property.values.value"></div>
                    </div>
                </template> -->

                <div class="btns" style="order:10001">
                    <div class="inner">
                        <button class="send-request b" @click="sendRequest(item.data.item.id, item.id, item.data.texts.name1)">
                            Für dieses Gerät voten
                        </button>

                        <!-- Normaler Artikel -->
                        <template v-for="property in item.data.variationProperties" v-if="property.property.id == 57 && property.values.value == ''">
                            <a :href="'#cross' + item.id" data-toggle="modal" class="a">Jetzt kaufen</a>

                            <div id="cross-modal-wrapper" class="cross-modal">
                                <div class="modal fade" :id="'cross' + item.id" tabindex="-1" role="dialog">
                                    <div class="modal-dialog modal-lg">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <div class="modal-title"><span>{{ item.data.texts.name3 }}</span> Folgende Varianten stehen zur Auswahl:</div>
                                                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                                            </div>
                                            <div class="modal-body">
                                                <template v-for="property in item.data.variationProperties" v-if="property.property.id == 58">
                                                    <div v-for="cross in crossSellingData" v-if="property.values.value.split(',').map(Number).includes(cross.id)" class="item">
                                                        <a :href="cross.data|itemURL">
                                                            <span class="img">
                                                                <span class="inner">
                                                                    <img :data-src="cross.data.images.all[0].urlMiddle" src="" alt="" class="lazyload">

                                                                    <span v-if="cross.data.prices.rrp && cross.data.prices.rrp.unitPrice.value > 0 && cross.data.prices.rrp.unitPrice.value > cross.data.prices.default.unitPrice.value && (100 - (cross.data.prices.default.unitPrice.value * 100 / cross.data.prices.rrp.unitPrice.value)) >= 10" class="bubble percent-sale">
                                                                        -{{ 100 - (cross.data.prices.default.unitPrice.value * 100 / cross.data.prices.rrp.unitPrice.value ).toFixed(0) }}%
                                                                    </span>
                                                                </span>
                                                            </span>
                                                            <span class="t">{{ cross.data.texts.name1 }}</span>
                                                            <span class="price-container">
                                                                <span v-if="cross.data.prices.rrp && cross.data.prices.rrp.unitPrice.value > 0 && cross.data.prices.rrp.unitPrice.value > cross.data.prices.default.unitPrice.value" class="rrp">
                                                                    UVP: <del>{{ cross.data.prices.rrp.unitPrice.formatted }}</del>
                                                                    <span>Sie sparen: {{ (cross.data.prices.rrp.unitPrice.value - cross.data.prices.default.unitPrice.value).toFixed(2).replace('.',',') }} &euro;</span>
                                                                </span>
                                                                <span class="p">{{ cross.data.prices.default.unitPrice.formatted }}</span>
                                                            </span>
                                                            <span class="c2a">Jetzt kaufen</span>
                                                        </a>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>

                        <!-- Amazon Artikel -->
                        <template v-for="property in item.data.variationProperties" v-if="property.property.id == 57 && property.values.value.startsWith('http')">
                            <a class="amz a" :href="property.values.value" target="_blank">Bei Amazon kaufen</a>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

</template>

<script>

setTimeout(function () {
    $(".overflow").animate({scrollLeft: 250 - 200}, 800);
    $(".overflow").animate({scrollLeft: 0}, 800);
}, 3000);

export default {
    data: function() {
        return {
            votingjson: [],
            loading: true,
            countVotes: 0
        }
    },

    delimiters: ['${', '}'],

    props: {
        manualSelection: {
            default: null,
            type: Array
        },
        votingId: {
            defaul: null
        },
        varProps: {
            default: null
        },
        winner: {
            default: null
        },
        recommendation: {
            default: null
        },
        crossSellingData: {
            default: null,
            type: Array
        }
    },

    created: function() {
        this.updateWidget()
    },

    mounted: function () {
        window.setInterval(() => {
            this.updateWidget()
        }, 5000)
    },

    methods: {
        updateWidget() {
            var self = this;
            $.getJSON('/rest/votingjson/' + parseInt(this.votingId)).done(function(data) {
                self.votingjson = data;

                // find highest count
                if (data.length  >= 1) {
                    var highest = data.reduce((a, b) => Number(a.count) > Number(b.count) ? a : b);

                    const sumTotal = arr => arr.reduce((sum, { count }) => sum + count, 0);
                    const total = sumTotal(data);

                    if (total == 1) {
                        $('#setTotalVotes').html(' (' + total + ' Stimme)')
                    } else {
                        $('#setTotalVotes').html(' (' + total + ' Stimmen)')
                    }
                }

                setTimeout(function() {
                    // add style order after json file is loaded
                    $('[data-count]').each(function(index, el) {
                        var attr = $(this).attr('data-count');
                        $(this).parents('.data-count').css('order', attr * -1).attr('data-order', attr);

                        $('.c-voting-container').removeAttr('style');

                        // sending data to "your favorite" widget
                        var percent = $(this).attr('data-percent');
                        var dataID = $(this).parent().parent().attr('data-id');

                        $('.favs .' + dataID).css('order', attr * -1).attr('data-order', attr);
                        $('.favs .' + dataID + ' .bar').css('width', 'calc(' + percent + '% - 4px)');
                        $('.favs .' + dataID + ' .bar-c + span').html(percent + '%');

                        self.loading = false;
                    });

                    // add class to highest item for styling
                    $('.i').removeClass('highest');

                    if (data.length >= 1) {
                        if ($('.c-voting .i[data-order="' + highest.count + '"').length == 1) {
                            $('.c-voting .i[data-order="' + highest.count + '"').addClass('highest');

                            var dataID = $('.c-voting .i[data-order="' + highest.count + '"').attr('data-id');
                            $('.favs .' + dataID).addClass('highest');
                        }
                    }
                }, 100);


                if (data.length == 0) {
                    $('.c-voting-container').removeAttr('style');

                    self.loading = false;
                }
            });

            (function($) {
                function equalizeHeights(selector) {
                    var heights = new Array();

                    $(selector).each(function() {
                        heights.push($(this).height());
                    });

                    var max = Math.max.apply(Math, heights);

                    $(selector).each(function() {
                        $(this).css('min-height', max + 1 + 'px');
                    });
                }

                $(document).ready(function() {
                    equalizeHeights('.c-voting .items .title');
                    equalizeHeights('.c-voting .items .price');
                    equalizeHeights('.c-voting .items .rating');
                    equalizeHeights('.c-voting .items .var-prop');
                    equalizeHeights('.c-voting .items .add-disa');
                    equalizeHeights('.c-voting .items .vote-container');
                    equalizeHeights('.c-voting .items .faz');
                    equalizeHeights('.c-voting .items .btns');
                    equalizeHeights('.c-voting .items .btnsx');
                });
            })(jQuery);
        },

        sendRequest(id, varId, itemName) {
            $('.favs .b, .send-request').addClass('muted');
            var self = this;

            var data = {
                'itemId': varId,
                'itemName': itemName,
                'category': parseInt(this.votingId)
            };

            $.ajax({
                type: "POST",
                url: "/voting",
                data: data,
                success: function(data) {
                    var data = jQuery.parseJSON(data);

                    self.updateWidget();

                    window.CeresNotification.success("Ihre Stimme wurde gezählt. Vielen Dank für Ihre Bewertung").closeAfter(5000);
                },
                error: function(data) {
                    window.CeresNotification.error("Es ist etwas schief gelaufen. Bitte versuchen Sie es später erneut").closeAfter(5000);
                }
            });
        }
    }
}

</script>
